export default async ({ store, redirect, route }) => {
  // Check if the user is indeed logged in (just in case).
  if (!store.state.session?.user) {
    return redirect(`/accounts/login/?next=${route.fullPath}`);
  }

  // Check that invoice UUID is present in the URL.
  const uuid = route.params?.uuid;
  if (!uuid) {
    return redirect('/account/products/');
  }

  // Fetch redemption data.
  await store.dispatch('redemption/updateRedemptionData', uuid);

  // Check that logged in user is the invoice owner.
  const currentUserId = parseInt(store.getters.userSession?.id, 10);
  const invoiceUserId = parseInt(store.getters['redemption/redemptionData']?.invoice[0]?.fields?.user, 10);
  if (currentUserId !== invoiceUserId) {
    return redirect('/404/');
  }

  return null;
};
